import { ThemeProvider, createTheme } from '@mui/material/styles';
import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';

export default function SheetDataGrid({ scriptUrl, defaultFilter = '' }) {
  const [columns, setColumns] = React.useState([]);
  const [rows, setRows] = React.useState([]);
  const [filteredRows, setFilteredRows] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const theme = createTheme();

  React.useEffect(() => {
    if (!scriptUrl) return;
    fetch(scriptUrl)
      .then((res) => res.json())
      .then((data) => {
        if (!data.headers || !data.rows) throw new Error('Malformed data');

        const cols = data.headers.map((header) => ({
          field: header.toString().replace(/\s+/g, '_').toLowerCase(),
          headerName: header,
          width: 200,
          editable: false,
        }));

        const processedRows = data.rows.map((row, idx) => {
          const rowData = { id: idx + 1 };
          data.headers.forEach((header) => {
            const key = header.toString().replace(/\s+/g, '_').toLowerCase();
            rowData[key] = row[header] || '';
          });
          return rowData;
        });

        setColumns(cols);
        setRows(processedRows);

        // Simple filtering logic
        if (defaultFilter) {
          const filtered = processedRows.filter((row) =>
            Object.values(row).some((value) =>
              value.toString().toLowerCase().includes(defaultFilter.toLowerCase())
            )
          );
          setFilteredRows(filtered);
        } else {
          setFilteredRows(processedRows);
        }
      })
      .catch((err) => {
        console.error('Data fetch error:', err);
      })
      .finally(() => setLoading(false));
  }, [scriptUrl, defaultFilter]);

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ height: 600, width: '100%', mb: 4 }}>
          <DataGrid
            rows={filteredRows}
            columns={columns}
            loading={loading}
            pageSizeOptions={[5, 10, 20]}
            initialState={{
              pagination: {
                paginationModel: { pageSize: 10 },
              },
              columns: {
                columnVisibilityModel: {
                  id: false,
                },
              },
            }}
            slots={{ toolbar: GridToolbar }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
                csvOptions: {
                  fileName: 'licensure_data',
                  delimiter: ';',
                  utf8WithBom: true,
                },
              },
            }}
            disableRowSelectionOnClick
          />
        </Box>
      </Box>
    </ThemeProvider>
  );
}
